import { render } from "./HomeAvatar.vue?vue&type=template&id=023f9204&scoped=true"
import script from "./HomeAvatar.vue?vue&type=script&lang=js"
export * from "./HomeAvatar.vue?vue&type=script&lang=js"

import "./HomeAvatar.vue?vue&type=style&index=0&id=023f9204&scoped=true&lang=scss"
import "./HomeAvatar.vue?vue&type=style&index=1&id=023f9204&lang=scss"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.44_vue@3.5.44_webpack@5.112.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-023f9204"]])

export default __exports__